import debounce from 'debounce';

// mobile menu

class MobileMenu extends HTMLElement {
  constructor() {
    super();
    // elements
    this.lastFocusedElement = null;
    this.menuId = this.getAttribute('id');
  }
  connectedCallback() {
    // binding
    this.bndHandleKeydown = this.handleKeydown.bind(this);
    // events
    document.addEventListener('keydown', this.bndHandleKeydown);
  }
  disconnectedCallback() {
    document.removeEventListener('keydown', this.bndHandleKeydown);
  }

  /**
   * Opens the menu
   * @param {HTMLElement} triggerElement - The element that triggered the menu opening
   */
  openMenu(triggerElement = null) {
    // Store the previously focused element
    this.lastFocusedElement = triggerElement || document.activeElement;

    // Toggle body class
    document.body.classList.add('is-with-menu');

    // Remove hidden attribute if present
    if (this.hasAttribute('hidden')) {
      this.removeAttribute('hidden');
    }

    // Focus the first focusable element in the menu
    setTimeout(() => {
      const focusableElements = this.getFocusableElements();
      if (focusableElements.length > 0) {
        focusableElements[0].focus();
      }
    }, 100);
  }

  /**
   * Closes the menu
   */
  closeMenu() {
    // Toggle body class
    document.body.classList.remove('is-with-menu');

    // Restore focus to the element that had focus before the menu was opened
    if (this.lastFocusedElement) {
      this.lastFocusedElement.focus();
      this.lastFocusedElement = null;
    }
    this.setAttribute('hidden', '');
  }

  /**
   * Toggle the menu state
   * @param {HTMLElement} triggerElement - The element that triggered the toggle
   */
  toggleMenu(triggerElement = null) {
    if (document.body.classList.contains('is-with-menu')) {
      this.closeMenu();
    } else {
      this.openMenu(triggerElement);
    }
  }

  /**
   * Handle keydown events - close on Escape key
   * @param {KeyboardEvent} event 
   */
  handleKeydown(event) {
    // Close menu on Escape keypress
    if (event.key === 'Escape' && document.body.classList.contains('is-with-menu')) {
      event.preventDefault();
      this.closeMenu();

      // Find the burger button and update its aria-expanded attribute
      const burgerButton = document.querySelector('.js-header__burger');
      if (burgerButton) {
        burgerButton.setAttribute('aria-expanded', 'false');

        // Restore original aria-label
        const originalLabel = burgerButton.getAttribute('data-label-open') || burgerButton.getAttribute('aria-label');
        if (originalLabel) {
          burgerButton.setAttribute('aria-label', originalLabel);
        }
      }
    }
  }

  /**
   * Get all focusable elements within the menu
   * @returns {Array} Array of focusable elements
   */
  getFocusableElements() {
    const focusableSelectors = ['a[href]:not([tabindex="-1"])', 'button:not([disabled]):not([tabindex="-1"])', '[tabindex]:not([tabindex="-1"])', 'input:not([disabled]):not([tabindex="-1"])', 'select:not([disabled]):not([tabindex="-1"])', 'textarea:not([disabled]):not([tabindex="-1"])'];
    return Array.from(this.querySelectorAll(focusableSelectors.join(',')));
  }
}
customElements.define('mobile-menu', MobileMenu);